import { getUserbrands } from '@/redux/actions/brands'
import { getCountries, getFilteredCountries } from '@/redux/actions/countries'
import { getCoursetypes } from '@/redux/actions/coursetypes'
import { getLanguages } from '@/redux/actions/languages'
import { getRoles } from '@/redux/actions/roles'
import { showTrainingResponsible } from '@/redux/actions/users'
import { IRootState } from '@/redux/types'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { IStatus, IVisibility } from '../../../models/course'

function useInitialState() {
  const dispatch = useDispatch()

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { userBrands } = useSelector((state: IRootState) => state.brand)
  const { coursetypes } = useSelector((state: IRootState) => state.coursetype)
  const { countries } = useSelector((state: IRootState) => state.country)
  const { languages } = useSelector((state: IRootState) => state.language)
  const { roles } = useSelector((state: IRootState) => state.role)

  const { t } = useTranslation(['global'])

  const STATUS: IStatus[] = [
    { id: 0, name: 'Inactivo' },
    { id: 1, name: 'Activo' },
    { id: 2, name: 'Borrador' }
  ]

  const VISIBILITY: IVisibility[] = [
    { id: 0, name: t('private') },
    { id: 1, name: 'VIP' },
    { id: 2, name: t('public') }
  ]

  useEffect(() => {
    dispatch(showTrainingResponsible())
    if (countries.length === 0) {
      if (authUser.role_id === 1) dispatch(getCountries())
      else dispatch(getFilteredCountries())
    }
    if (userBrands.length === 0) dispatch(getUserbrands())
    if (coursetypes.length === 0) dispatch(getCoursetypes())
    if (languages.length === 0) dispatch(getLanguages())
    if (roles.length === 0) dispatch(getRoles())
  }, [])

  return { STATUS, VISIBILITY }
}

export default useInitialState
